import React from 'react'

import { Col, Form } from '_zari/core'

const AsientoContableFormGroup = ({ idAsientoContable, setIdAsientoContable, listaAsientosContables, limpiarIdDocumento }) => {
  return (
    <Form.Group>
      <Form.Label text='DOCUMENTO' md={12} alignRightAt='md' />
      <Col md={12}>
        <Form.Select
          id='input-asientoContable'
          name='input-asientoContable'
          value={idAsientoContable}
          onChange={e => {
            setIdAsientoContable(e.target.value)
            limpiarIdDocumento()
          }}
        >
          <option value=''>Seleccionar</option>
          {listaAsientosContables.map((x, k) => (
            <option key={k} value={x._id}>{`${x.tipoDocumento} - ${x.serieDocumento} - ${x.numeroDocumento}`}</option>
          ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(AsientoContableFormGroup)
